module.exports = __webpack_public_path__ + "img/33.0978cba3.jpg";